module.exports = "<p>\n  marketplaces works!\n</p>\n"